import {
  BorderedBox,
  ContentBox,
  GridLabel,
  GridValue,
  Heading2,
} from './ClientConfigToolStyles'
import { ClientData } from '../atoms/clientConfigState'
import { Grid } from '@mui/material'
import React from 'react'

interface ClientDetailProps {
	client: ClientData
}

function ClientDetails({ client }: ClientDetailProps) {
  const getAddress = () => {
    let address = ''
    address += client.client_street ? client.client_street + ', ' : ''
    address += client.client_street2 ? client.client_street2 + ', ' : ''
    address += client.client_city ? client.client_city + ', ' : ''
    address += client.client_state ? client.client_state + ', ' : ''
    address += client.client_zip ? client.client_zip : ''
    return address
  }

  return (
    <BorderedBox>
      <ContentBox>
        <Grid container direction="column" rowSpacing={2.35}>
          <Grid item>
            <Heading2>Client details</Heading2>
          </Grid>
          <Grid container direction="column" item rowSpacing={1}>
            <Grid alignItems="center" columns={16} container direction="row" item>
              <GridLabel item xs={1}>
							Client name
              </GridLabel>
              <GridValue item>{client.client_name}</GridValue>
            </Grid>
            <Grid alignItems="center" columns={16} container direction="row" item>
              <GridLabel item xs={1}>
							Client id
              </GridLabel>
              <GridValue item>{client.client_id}</GridValue>
            </Grid>
            <Grid alignItems="center" columns={16} container direction="row" item>
              <GridLabel item xs={1}>
							Address
              </GridLabel>
              <GridValue item>{getAddress()}</GridValue>
            </Grid>
            <Grid alignItems="center" columns={16} container direction="row" item>
              <GridLabel item xs={1}>
							Phone
              </GridLabel>
              <GridValue item>{client.client_phone}</GridValue>
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
    </BorderedBox>
  )
}

export default ClientDetails
